// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Ejkh","head":"ProcedureTableInfo_head__2I2oz"};